<template>
    <header class="login_header">
        <el-row :gutter="24" class="login_header_container">
          <el-col :span="14">
            <div class="login_logo">
              <img :src="loginlogo" class="login_logo_img" alt="万德付">
            </div>
          </el-col>
          <el-col :span="6">
            <el-menu :default-active="activeItem" background-color="#F8F9FE" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="1">账号登录</el-menu-item>
              <el-menu-item index="2">APP下载</el-menu-item>
            </el-menu>
          </el-col>
          <el-col :span="4">
            <div class="login_link">
              <span class="login_link_number">400-992-1588</span>
            </div>
          </el-col>
        </el-row>
     </header>
</template>
<script>
import loginlogo  from '@/assets/images/login_logo.png';
export default {
    name: "loginHeader",
    props: {
         activeIndex: {}
    },
    data() {
        return {
          loginlogo,
          activeItem:this.activeIndex,
        }
    },
    mounted() {
        // this.orderNum = this.counts;
        // this.setNumberTransform();
    },
    methods: {
       //监听变化 
       handleSelect(key) {
         this.$emit('upActiveIndex',key);
        // console.log(key, keyPath);
      }
       
    }
}
</script>
<style scoped lang='scss'>
.el-menu.el-menu--horizontal{
  border-bottom: none;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 2px solid #5111ee;
}

.login_header{
    height: 150px;
    border-bottom: 1px solid #D9DADB;
    width: 100%;
    overflow: hidden;
      .login_header_container{
        height: 100%;
        padding:50px;
        .login_logo{
            height:100%;
            .login_logo_img{
               top:10px;
            }
        }
        .login_tab_box{
           
        }
        .login_link{
            height: 100%;
            text-align: right;
            &_number{
                line-height: 55px;
                font-size: 30px;
                font-weight: bold;
            }
        }
      }
  }
</style>